<template>
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="出售中" name="sell">
          <span slot="label">出售中 <el-tag size="mini">{{ productCount.sell }}</el-tag></span>
        </el-tab-pane>
        <el-tab-pane label="仓库中" name="lower">
          <span slot="label">仓库中 <el-tag size="mini">{{ productCount.lower }}</el-tag></span>
        </el-tab-pane>
        <el-tab-pane label="回收站" name="recovery">
          <span slot="label">回收站 <el-tag size="mini">{{ productCount.recovery }}</el-tag></span>
        </el-tab-pane>
        <el-tab-pane label="库存紧张" name="stock">
          <span slot="label">库存紧张 <el-tag size="mini">{{ productCount.stock }}</el-tag></span>
        </el-tab-pane>
        <!--        <el-tab-pane label="草稿箱" name="draft">-->
        <!--          <span slot="label">草稿箱 <el-tag size="mini">{{ productCount.draft }}</el-tag></span>-->
        <!--        </el-tab-pane>-->
        <el-tab-pane label="待审核" name="audit">
          <span slot="label">待审核 <el-tag size="mini">{{ productCount.audit }}</el-tag></span>
        </el-tab-pane>
        <el-tab-pane label="未通过" name="noAudit">
          <span slot="label">未通过 <el-tag size="mini">{{ productCount.noAudit }}</el-tag></span>
        </el-tab-pane>
      </el-tabs>
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/product/product/add'">
            添加商品
          </el-button>
        </el-form-item>
        <!--        <el-form-item>-->
        <!--          <el-button size="small" type="primary" icon="el-icon-plus" @click="selectProductClick()">添加分销产品-->
        <!--          </el-button>-->
        <!--        </el-form-item>-->
        <el-form-item label="商品分类">
          <el-cascader
            v-model="currCategory"
            ref="cascader"
            clearable
            :options="categoryList"
            :props="{ checkStrictly: true, children: 'children', value: 'categoryId', label: 'name' }"
            @change="changeCategory"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input size="small" v-model="searchForm.productName" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item v-if="hasWDTConfig">
          <el-upload class="avatar-uploader" multiple ref="upload" action="string" accept=".xlsx,.xls"
                     :before-upload="onBeforeUploadImage" :http-request="UploadImage" :show-file-list="false"
                     :on-change="fileChange">
            <el-button size="small" icon="el-icon-upload" type="primary">点击上传规格价格</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>

    <!--添加产品-->
    <!--    <div class="common-level-rail">-->
    <!--      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/product/product/add'">-->
    <!--        添加产品-->
    <!--      </el-button>-->
    <!--    </div>-->

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="productName" label="产品">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.imagePath" alt=""/></div>
                <div class="info">
                  <div class="name">{{ scope.row.productName }}</div>
                  <div class="price">￥{{ scope.row.supplierPrice }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="productBrand" label="品牌" width="240px"></el-table-column>
          <el-table-column prop="categoryName" label="分类" width="240px">
            <template slot-scope="scope">
              <span>
                {{ getShowCategoryName(scope.row.productCategoryReList) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="salesActual" label="实际销量" width="180"></el-table-column>
          <!--          <el-table-column prop="salesActual" label="销售金额" width="100px"></el-table-column>-->
          <!--                    <el-table-column prop="productStock" label="库存" width="180"></el-table-column>-->
          <el-table-column prop="viewTimes" label="点击数量" width="160px"></el-table-column>
          <!--          <el-table-column label="商品属性">-->
          <!--            <template slot-scope="scope">-->
          <!--              <span v-if="scope.row.isVirtual == 0">实物商品</span>-->
          <!--              <span v-if="scope.row.isVirtual == 1" class="green">虚拟商品</span>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column prop="createTime" label="发布时间" width="150"></el-table-column>
          <el-table-column prop="auditRemark" label="拒绝原因" v-if="activeName === 'noAudit'"
                           width="160px"></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope" v-if="supplierStatus==0">
              <div class="table-btn-column">
                <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/product/product/edit'">
                  编辑商品
                </el-button>
                <el-button @click="delClick(scope.row)" type="text" size="small" v-auth="'/product/product/delete'">
                  删除商品
                </el-button>
                <el-button v-if="activeName == 'sell'" @click="changeStatus(scope.row,20)" type="text"
                           size="small"
                           v-auth="'/product/product/edit'">立即下架
                </el-button>
                <el-button v-if="activeName == 'lower'" @click="changeStatus(scope.row, 10)" type="text" size="small"
                           v-auth="'/product/product/edit'">立即上架
                </el-button>
                <el-button v-if="activeName == 'sell' || activeName == 'lower'"
                           @click="onUpChangeStatusClick(scope.row)" type="text"
                           v-auth="'/product/product/edit'">规格上下架

                </el-button>
                <el-button v-if="activeName == 'recovery'" @click="changeStatus(scope.row, 20)" type="text" size="small"
                           v-auth="'/product/product/edit'">恢复商品
                </el-button>
                <el-button @click="copyClick(scope.row)" type="text" size="small" v-auth="'/product/product/edit'">
                  一键复制
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>
    <getproduct :isproduct="open_product" :islist="true" @closeDialog="closeDialogFunc($event, 'add')"/>
    <el-dialog title="规格上下架管理" :visible.sync="dialogVisible" :close-on-click-modal="false" width="35%"
               @close="dialogFormVisible"
               :close-on-press-escape="false" :append-to-body="true">
      <div class="fs-14 bold">
        商品名称：{{ selectRowForm.productName }}
      </div>
      <div class="m-t-10">
        <el-table size="small" :data="selectRowForm.skuList" border style="width: 100%"
                  @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column prop="specName" label="规格名称"></el-table-column>
          <el-table-column prop="productNo" label="商家编码"></el-table-column>
          <el-table-column prop="specNo" label="规格码"></el-table-column>
          <el-table-column prop="skuStatus" label="规格状态" width="80">
            <template slot-scope="scope">
              <span style="color: #00aa54" v-if="scope.row.skuStatus === 0">已上架</span>
              <span style="color: red" v-if="scope.row.skuStatus === 1">已下架</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible=false">取 消</el-button>
        <el-button size="small" type="primary" @click="changeSpecStatus(1)">规格下架</el-button>
        <el-button size="small" type="primary" @click="changeSpecStatus(0)">规格上架</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js'
import getproduct from '@/components/product/Product.vue'

export default {
  components: {getproduct},
  data () {
    return {
      /*切换菜单*/
      activeName: 'sell',
      /*切换选中值*/
      activeIndex: '0',
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 15,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        productName: '',
        categoryId: ''
      },
      /*列表数据*/
      tableData: [],
      /*全部分类*/
      categoryList: [],
      productCount: {},
      open_product: false,
      dialogVisible: false,
      selectRowForm: {
        productName: '',
        skuList: undefined
      },
      multipleSelection: [],
      /*当前选中的*/
      currCategory: [],
      hasWDTConfig: 0
    }
  },
  created () {
    /*获取列表*/
    this.getData()
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.loading = true
      self.curPage = val
      self.getData()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.pageSize = val
      this.getData()
    },

    /*切换菜单*/
    handleClick (tab, event) {
      let self = this
      self.curPage = 1
      self.getData()
    },

    /*获取列表*/
    getData () {
      let self = this
      let Params = self.searchForm
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      Params.type = self.activeName
      self.loading = true
      PorductApi.supplierProductList(Params, true)
        .then(res => {
          self.loading = false
          self.tableData = res.data.productList.records
          self.categoryList = res.data.categoryList
          self.totalDataNumber = res.data.productList.total
          self.productCount = res.data.productCount
          self.supplierStatus = res.data.supplierStatus
          self.hasWDTConfig = res.data.hasWDTConfig || 0
        })
        .catch(error => {
          self.loading = false
        })
    },

    /*搜索查询*/
    onSubmit () {
      this.curPage = 1
      this.getData()
    },

    /*打开添加*/
    addClick () {
      this.$router.push('/product/product/add')
    },

    /*打开编辑*/
    editClick (row) {
      console.log(row)
      this.$router.push({
        path: '/product/product/edit',
        query: {
          productId: row.productId,
          scene: 'edit'
        }
      })
    },

    linkClick: function (val) {
      let self = this
      let copyText = 'pages/product/detail/detail?productId=' + val
      self.$copyText(copyText).then(function (e) {
        self.$message({
          showClose: true,
          message: '复制成功',
          type: 'success'
        })
      }, function (e) {
        self.$message({
          showClose: true,
          message: '复制失败',
          type: 'error'
        })
      })
    },
    /*打开复制*/
    copyClick (row) {
      this.$router.push({
        path: '/product/product/edit',
        query: {
          productId: row.productId,
          scene: 'copy'
        }
      })
    },
    /*删除*/
    delClick: function (row) {
      let self = this
      let msg = ''
      if (row.productStatus == 30) {
        msg = '删除后不可恢复，确认删除该记录吗?'
      } else {
        msg = '删除后将移动到回收站，确定删除该记录吗?'
      }
      self
        .$confirm(msg, '提示', {
          type: 'warning'
        })
        .then(() => {
          PorductApi.delProduct({
            productId: row.productId
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            })
            self.getData()
          })
        })
    },
    onUpChangeStatusClick (row) {
      this.selectRowForm = {
        productName: row.productName,
        skuList: row.sku
      }
      this.dialogVisible = true
    },
    changeSpecStatus (status) {
      let self = this
      if (this.multipleSelection && this.multipleSelection.length) {
        let productSkuIds = this.multipleSelection.map(item => {
          return item.productSkuId
        })
        PorductApi.changeSpecsStatus({
          productSkuIds: productSkuIds.join(','),
          skuStatus: status
        }, true).then(data => {
          self.$message({
            message: '操作成功',
            type: 'success'
          })
          self.dialogVisible = false
          self.getData()
        })
      } else {
        this.$message({
          message: '请选择规格',
          type: 'success'
        })
      }
    },
    /*修改状态*/
    changeStatus (item, value) {
      let self = this
      let msg = ''
      if (value == 10) {
        msg = '确认要上架该商品吗?'
      } else {
        msg = '确认要下架该商品吗?'
        if (self.activeName == 'recovery') {
          msg = '确认要移动该商品到仓库吗?'
        }
      }
      self.$confirm(msg, '提示', {
        type: 'warning'
      }).then(() => {
        PorductApi.changeStatus({
          productId: item.productId,
          state: value
        }).then(data => {
          self.$message({
            message: '操作成功',
            type: 'success'
          })
          self.getData()
        })
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    dialogFormVisible () {
      this.multipleSelection = []
      this.selectRowForm = {
        productName: '',
        skuList: undefined
      }
    },
    /*打开弹出层*/
    selectProductClick () {
      this.open_product = true
    },

    /*关闭获取用户弹窗*/
    closeDialogFunc (e) {
      let self = this
      if (e.type != 'error') {
        // this.userInfo = e.params[0];
        // this.form.supplier.userId = e.params[0].userId;
        let productIds = []

        productIds = e.params.map(item => {
          return item.productId
        })

        let params = {
          productIds: productIds
        }
        PorductApi.addSupplierProduct(params).then(res => {

          self.$message({
            message: '添加成功',
            type: 'success'
          })
          self.getData()
        }).catch(err => {
          self.$message({
            message: err.msg || '添加失败',
            type: 'error'
          })
        })
      }
      this.open_product = false
    },
    getShowCategoryName (list) {
      let text = ''
      if (list && list.length) {
        text = list.map(item => {
          return item.categoryName
        }).join(',')
      }
      return text
    },
    changeCategory (e) {
      let item = this.$refs['cascader'].getCheckedNodes()
      if (item && item.length) {
        this.searchForm.categoryId = item[0].data.categoryId
      } else {
        this.searchForm.categoryId = ''
      }
    },
    /*选择图片之前*/
    onBeforeUploadImage (file) {
      return true
    },
    /*选择上传图片*/
    fileChange (e) {
      console.log(e)
    },
    UploadImage (param) {
      let self = this
      const loading = this.$loading({
        lock: true,
        text: 'Excel文件上传中,请等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const formData = new FormData()
      formData.append('iFile', param.file)
      PorductApi.uploadExcelFile(formData)
        .then(response => {
          if (response.data) {
            self.$message({
              message: '未处理商家编码:' + response.data,
              type: 'warning'
            })
          }
          self.getData()
          loading.close()
        })
        .catch(response => {
          loading.close()
          self.$message({
            message: '本次上传Excel文件失败',
            type: 'warning'
          })
        })
    },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/product/product/index.vue